export default class States {
    public static link:string = "Link";
    public static gameOverFail:string = "Game Over Fail";
    public static restart:string = "Restart Game";
    public static nextChapter:string = "Next Chapter";
    public static gameOverSuccess:string = "Game Over Success";
    public static backAStep:string = "Back A Step";
}



// WEBPACK FOOTER //
// ./src/objects/States.ts